import { Pipe, PipeTransform } from '@angular/core';

import { LanguageService } from '../services/language.service';

@Pipe({
  name: 'pepCurrency',
})
export class PepCurrencyPipe implements PipeTransform {
  constructor(public languageService: LanguageService) {}

  transform(
    value: number,
    currency: string,
    locale: string,
    maxDP = 4,
    minDP = 2,
  ): any {
    if (isNaN(value) || !currency) {
      return value;
    }

    return this.languageService.formatCurrency(
      value,
      currency,
      locale,
      maxDP,
      minDP,
    );
  }
}
